import '../social_content_previous_comments_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.GoogleMyBusinessContentPreviousCommentsView extends
Monitoring.Views.SocialContentPreviousCommentsView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, {use_defaults: false})
    @searchQuery.addContextKind('gmb_previous_comments')
    @addContextLimit()
    @searchQuery.addGMBParentReviewId(@rootParentId)
    @addDates()
    @searchQuery.removeDateFromRealtime()
    @searchQuery.setNowDate(false)
